// extracted by mini-css-extract-plugin
export var background = "hello-module--background--gWSoM";
export var button = "hello-module--button--f9243";
export var buttons = "hello-module--buttons--2kx1h";
export var component = "hello-module--component--QlPcQ";
export var container = "hello-module--container--YxnGz";
export var icon = "hello-module--icon--jJVM8";
export var logo = "hello-module--logo--6MvXV";
export var tagline = "hello-module--tagline--l00gY";